import { Routes, Route, Navigate } from "react-router-dom";
import Posts from "../pages/posts/posts.js";
import Post from "../pages/post/post.js";
import Home from "../pages/home/home.jsx";
import Banner from "../pages/banner/banner.js";
import Colunistas from "../pages/colunistas/colunistas.js";
import PostsColunistas from "../pages/colunistas/posts-colunistas.js";
import Videos from "../pages/videos/videos.js"
import Materias from "../pages/materias/materias.js";
import Materia from "../pages/materia/materia.js";
import MidiasFooterAdmin from "../pages/midias_footer/midias_footer.js";
import PostColunista from "../pages/colunistas/post-colunista/post-colunista.js";




export default function RoutesPrivate() {
  return (
    <Routes>


      <Route path="/home" element={<Home />} />
      <Route path="/posts" element={<Posts />} />
      <Route path="/posts/admin/:id_post" element={<Post />} />
      <Route path="/banners" element={<Banner />} />
      <Route path="/colunistas" element={<Colunistas />} />
      <Route path="/admin/colunistas/:id_colunista/posts" element={<PostsColunistas />} />
      <Route path="/videos" element={<Videos />} />
      <Route path="/materias" element={<Materias />} />
      <Route path="/materias/:id_materia" element={<Materia />} />
      <Route
        path="/admin/colunistas/:id_colunista/posts/:id_post_colunista"
        element={<PostColunista />}
      />

      <Route
          path="/posts/admin/:id_post/midias"
          element={<MidiasFooterAdmin tipo="post" />}
        />

        <Route
          path="/materias/admin/:id_materia/midias"
          element={<MidiasFooterAdmin tipo="materia" />}
        />

      
      

      
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
}